import { PERMISSION_TYPE, type PERMISSION_VALUE } from '../../index'
import { ROLE_TYPE } from '../permissions'

export enum FILE_ATTACHMENTS_PERMISSION {
  ATTACH_FILE = 'ATTACH_FILE',
}

export const getFileAttachmentPermissionsMatrix = (): Record<
  FILE_ATTACHMENTS_PERMISSION,
  Record<ROLE_TYPE, PERMISSION_VALUE>
> => ({
  [FILE_ATTACHMENTS_PERMISSION.ATTACH_FILE]: {
    [ROLE_TYPE.PRO_LOGGED]: { type: PERMISSION_TYPE.YES },
    [ROLE_TYPE.TEAM_AGENCY_LOGGED]: { type: PERMISSION_TYPE.YES },
    [ROLE_TYPE.TRIAL_LOGGED]: { type: PERMISSION_TYPE.NO },
    [ROLE_TYPE.TRIAL_ANONYMOUS]: { type: PERMISSION_TYPE.NO },
    [ROLE_TYPE.FREE_ANONYMOUS]: { type: PERMISSION_TYPE.NO },
    [ROLE_TYPE.FREE_LOGGED]: { type: PERMISSION_TYPE.NO },
    [ROLE_TYPE.FREE_PROJECT_MEMBER]: { type: PERMISSION_TYPE.NO },
    [ROLE_TYPE.FREE_OWNER]: { type: PERMISSION_TYPE.NO },
    [ROLE_TYPE.PRO_ANONYMOUS]: { type: PERMISSION_TYPE.NO },
    [ROLE_TYPE.PRO_PROJECT_MEMBER]: { type: PERMISSION_TYPE.YES },
    [ROLE_TYPE.PRO_OWNER]: { type: PERMISSION_TYPE.YES },
    [ROLE_TYPE.TEAM_AGENCY_ANONYMOUS]: { type: PERMISSION_TYPE.NO },
    [ROLE_TYPE.TEAM_AGENCY_PROJECT_MEMBER]: { type: PERMISSION_TYPE.YES },
    [ROLE_TYPE.TEAM_AGENCY_MEMBER]: { type: PERMISSION_TYPE.YES },
    [ROLE_TYPE.TEAM_AGENCY_OWNER]: { type: PERMISSION_TYPE.YES },
  },
})
